<script setup>
import { useComingSoonMessage } from '~/components/home/utils/message'

const props = defineProps({
  icon: {
    type: [Object, String],
    default: '',
  },
  href: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  action: {
    type: Function,
    default: () => {},
  },
  itemClass: {
    type: String,
  },
  selectedIcon: {
    type: [Object, Boolean],
    default: false,
  },
})
const route = useRoute()
const isActive = computed(() => props.name && route.name?.includes(props.name))
const showComingSoonMessage = useComingSoonMessage()
</script>

<template>
  <NuxtLink
    v-if="href"
    :to="href"
    class="flex items-center mx-3 h-[62px] rounded-lg px-3 hover:bg-inputHovered"
    :class="[{ 'bg-inputHovered': isActive, 'relative': selectedIcon }, props.itemClass]"
  >
    <component :is="icon" v-if="icon" class="w-8 h-8 me-2 text-textPrimary" />
    <span>{{ label }}</span>
    <component :is="selectedIcon" v-if="selectedIcon" class="absolute w-4 h-4 -translate-y-1/2 top-1/2 end-2 text-functionalCyan3" />
  </NuxtLink>
  <div
    v-else
    class="flex items-center mx-3 h-[62px] rounded-lg px-3 hover:bg-inputHovered cursor-pointer"
    :class="[{ 'bg-inputHovered': isActive, 'relative': selectedIcon }, props.itemClass]"
    @click="action?.() || showComingSoonMessage()"
  >
    <component :is="icon" v-if="icon" class="w-8 h-8 me-2 text-textPrimary" />
    <span>{{ label }}</span>
    <component :is="selectedIcon" v-if="selectedIcon" class="absolute w-4 h-4 -translate-y-1/2 top-1/2 end-2 text-functionalCyan3" />
  </div>
</template>
